export const INITIAL_STATE = {};

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/COMPANY_WITHIN_PORTFOLIO":
            const payload = action.payload;
            return {...state, ...payload, failure: null};
        case "SUBSCRIPTION_DATA_FAILED/COMPANY_WITHIN_PORTFOLIO":
            return {...state, failure: action.payload};
        case "SUBSCRIPTION_ENDED/COMPANY_WITHIN_PORTFOLIO":
            return INITIAL_STATE;
        default:
            return state;
    }
}
